<script lang="ts">
	
	import {afterUpdate, onMount} from "svelte";
    import Prestation, { PrestationProps } from "../components/Prestation.svelte";
    import PrestationContact, { PrestationContactProps } from "../components/PrestationContact.svelte";
    import ServicesIntro from "../components/DomainIntro.svelte";
	import {scrollTo} from "../scripts/commons";
    import {
        idPageServices,
        idPageServicesAssainissement,
        idPageServicesBalayage,
        idPageServicesContact,
    } from "../scripts/router2";
	import { storeAnchorToLight, storeIsFirstDisplay } from "../scripts/store";

	export let anchor: string = "services";

	let imagesMobileAssainissement: string[] = [];
	imagesMobileAssainissement.push("mobile-services/assainissement/prestation-assainissement-1.jpg");
	imagesMobileAssainissement.push("mobile-services/assainissement/prestation-assainissement-2.jpg");
	imagesMobileAssainissement.push("mobile-services/assainissement/prestation-assainissement-3.jpg");
	imagesMobileAssainissement.push("mobile-services/assainissement/prestation-assainissement-4.jpg");
	imagesMobileAssainissement.push("mobile-services/assainissement/prestation-assainissement-5.png");
	imagesMobileAssainissement.push("mobile-services/assainissement/prestation-assainissement-7.jpg");

	let imagesDesktopAssainissement: string[] = [];
	imagesDesktopAssainissement.push("services/assainissement/prestation-assainissement-1.png");
	imagesDesktopAssainissement.push("services/assainissement/prestation-assainissement-2.png");
	imagesDesktopAssainissement.push("services/assainissement/prestation-assainissement-3.png");
	imagesDesktopAssainissement.push("services/assainissement/prestation-assainissement-4.png");
	imagesDesktopAssainissement.push("services/assainissement/prestation-assainissement-5.png");
	imagesDesktopAssainissement.push("services/assainissement/prestation-assainissement-7.png");

	const slash: string = "<span style='color:#1280FF; font-weight:700;'>/&nbsp;</span>";
	let prestationTextAssainissement: string = "Nos équipes spécialisées dans l’ouverture de tranchées et la pose de réseaux vous proposent :<br>";
	prestationTextAssainissement = prestationTextAssainissement + slash;
	prestationTextAssainissement = prestationTextAssainissement + "Génie Civil pour réseaux électriques et Télécoms<br>";
	prestationTextAssainissement = prestationTextAssainissement + slash;
	prestationTextAssainissement = prestationTextAssainissement + "Raccordement tout à l'égout<br>";
	prestationTextAssainissement = prestationTextAssainissement + slash;
	prestationTextAssainissement = prestationTextAssainissement + "Pose de micro station<br>";
	prestationTextAssainissement = prestationTextAssainissement + slash;
	prestationTextAssainissement = prestationTextAssainissement + "Pose de Filière compacte<br>";
	prestationTextAssainissement = prestationTextAssainissement + slash;
	prestationTextAssainissement = prestationTextAssainissement + "Génie Civil pour l’installation de bornes IRVE (Infrastructure de Recharge de Véhicule Électrique)";

	const prestationAssainissement: PrestationProps = {
		id: "assainissement",
		title: "ASSAINISSEMENT - RÉSEAUX",
		text: prestationTextAssainissement,
		imagesMobile: imagesMobileAssainissement,
		imagesDesktop: imagesDesktopAssainissement
	}

	let imagesMobileBalayage: string[] = [];
	imagesMobileBalayage.push("mobile-services/balayage/prestation-balayage-0.png");
	imagesMobileBalayage.push("mobile-services/balayage/prestation-balayage-1.jpg");
	imagesMobileBalayage.push("mobile-services/balayage/prestation-balayage-2.jpg");
	imagesMobileBalayage.push("mobile-services/balayage/prestation-balayage-5.jpg");
	imagesMobileBalayage.push("mobile-services/balayage/prestation-balayage-6.jpg");
	imagesMobileBalayage.push("mobile-services/balayage/prestation-balayage-7.jpg");
	imagesMobileBalayage.push("mobile-services/balayage/prestation-balayage-8.jpg");

	let imagesDesktopBalayage: string[] = [];
	imagesDesktopBalayage.push("services/balayage/prestation-balayage-0.png");
	imagesDesktopBalayage.push("services/balayage/prestation-balayage-1.png");
	imagesDesktopBalayage.push("services/balayage/prestation-balayage-2.png");
	imagesDesktopBalayage.push("services/balayage/prestation-balayage-5.png");
	imagesDesktopBalayage.push("services/balayage/prestation-balayage-6.jpg");
	imagesDesktopBalayage.push("services/balayage/prestation-balayage-7.jpg");
	imagesDesktopBalayage.push("services/balayage/prestation-balayage-8.jpg");

	let prestationTextBalayage: string = "Équipées d’une rampe haute pression pour le balayage des caniveaux, des voies de circulation et d’autres prestations de balayage et de lavage type :<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Travaux Publics<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Voirie<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Balayage industriel<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Entretien routier<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Nettoyage<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Aspiration<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Arrosage<br>";
	prestationTextBalayage = prestationTextBalayage + slash;
	prestationTextBalayage = prestationTextBalayage + "Nos balayeuses sont récentes et parfaitement entretenues pour vous garantir des prestations optimales de jour comme de nuit sur tout le 44";

	const prestationBalayage: PrestationProps = {
		id: "balayage",
		title: "BALAYAGE AVEC CHAUFFEUR",
		text: prestationTextBalayage,
		imagesMobile: imagesMobileBalayage,
		imagesDesktop: imagesDesktopBalayage
	}

	let prestationTextContact: string = "208 Saint Jacques<br>";
	prestationTextContact = prestationTextContact + "44850 St Mars Du Désert<br>";
	prestationTextContact = prestationTextContact + slash;
	prestationTextContact = prestationTextContact + "T. 02 72 17 79 73<br>";
	prestationTextContact = prestationTextContact + slash;
	prestationTextContact = prestationTextContact + "<a href='mailto:contact@attalservices.fr' target='_blank' style='color:#FFFFFF; text-decoration:none;'>contact@attalservices.fr</a><br>";
	prestationTextContact = prestationTextContact + slash;
	prestationTextContact = prestationTextContact + "<a href='mailto:balayage@attalservices.fr' target='_blank' style='color:#FFFFFF; text-decoration:none;'>balayage@attalservices.fr</a>";
	const prestationContact: PrestationContactProps = {
		id: "services-contact",
		title: "ATTAL SERVICES",
		text: prestationTextContact,
	}

	let anchorPositionAssainissement: number = 0;
	let anchorPositionBalayage: number = 0;
	let anchorPositionContact: number = 0;

	afterUpdate(() => {
		anchorPositionAssainissement = document.getElementById(idPageServicesAssainissement).getBoundingClientRect().top;
		anchorPositionBalayage = document.getElementById(idPageServicesBalayage).getBoundingClientRect().top;
		anchorPositionContact = document.getElementById(idPageServicesContact).getBoundingClientRect().top;
	})

	onMount(async () => {
		scrollTo(anchor);
	});

    /**
     * scrollInPage
     */
     function scrollInPage() {
        let currentTop = window.scrollY;
		currentTop = currentTop + 75;
        if (currentTop < anchorPositionAssainissement) {
			storeAnchorToLight.set("");
        }
        if (currentTop > anchorPositionAssainissement && currentTop < anchorPositionBalayage) {
			storeAnchorToLight.set(idPageServicesAssainissement);
        }
        if (currentTop > anchorPositionBalayage && currentTop < anchorPositionContact) {
			storeAnchorToLight.set(idPageServicesBalayage);
        }
        if (currentTop > anchorPositionContact) {
			storeAnchorToLight.set(idPageServicesContact);
        }
    }

</script>

<svelte:window on:scroll={scrollInPage} />
{#if $storeIsFirstDisplay}
<div class="fonduintro">
</div>
{:else}
<div class="fondudomaine">
</div>
{/if}
<div class="services__anchor" id={idPageServices}></div>
<div class="services">
	<h1 class="services__hi">Attal Services</h1>
	<ServicesIntro />
	<div class="services__anchor" id={idPageServicesAssainissement}></div>
	<h2 class="services__hi">{prestationAssainissement.title}</h2>
	<h3 class="services__hi">Terrassement,&nbsp;Raccordement tout à l'égout,&nbsp;Micro station</h3>
	<Prestation props={prestationAssainissement}/>
	<div class="services__anchor" id={idPageServicesBalayage}></div>
	<h2 class="services__hi">{prestationBalayage.title}</h2>
	<h3 class="services__hi">Balayage voirie,&nbsp;Balayeuse THP,&nbsp;Nettoyage plateforme</h3>
	<Prestation props={prestationBalayage}/>
	<div class="services__anchor" id={idPageServicesContact}></div>
	<div class="services__contact">
		<h2 class="services__hi">{prestationContact.title}</h2>
		<h3 class="services__hi">Location matériel tp,&nbsp;Prestation service,&nbsp;Mini pelle,&nbsp;travaux forestiers</h3>
		<PrestationContact props={prestationContact}/>
	</div>
</div>

<style lang="scss">
	
	:global(body) {
		padding: 0;
		margin: 0;
		min-height: 100%;
		height: 100%;
		background-color: $color-bleu-instit;
		color: $color-white;
	}

	.fonduintro {
		z-index: 10000000;
		position: absolute;
		top: 0;
		width: 100%;
		height: 200%;
		animation-fill-mode: forwards;
		animation-name: firstfadeout;
		background-color: $color-bleu-instit;
		animation-duration: 2s;
	}

	.fondudomaine {
		z-index: 10;
		position: absolute;
		width: 100%;
		height: 200%;
		animation-fill-mode: forwards;
		animation-name: fadeout;
		background-color: $color-bordeau-instit;
		animation-duration: 1.5s;
	}

	.services {
		display: grid;
		grid-template-columns: 1fr;
		padding: calc($header-height + 15px) 0 0 0;
		&__hi {
			display: none;
		}
		&__anchor {
			scroll-margin-top: calc($header-height + 30px);
		}
		&__contact {
			min-height: 100vh;
		}
	}

	@include large {
	}

    @keyframes fadeout {
        0% {opacity: 1; height: 200%;}
		75% {opacity: 1; height: 200%;}
		99% {height: 200%;}
        100% {opacity: 0; height: 0;}
    }

    @keyframes firstfadeout {
        0% {opacity: 1; height: 200%;}
		99% {height: 200%;}
        100% {opacity: 0; height: 0;}
    }

</style>